import { render } from "./GetInAppPurchasedAmountEditorCmp.vue?vue&type=template&id=b185105c"
import script from "./GetInAppPurchasedAmountEditorCmp.vue?vue&type=script&lang=js"
export * from "./GetInAppPurchasedAmountEditorCmp.vue?vue&type=script&lang=js"

import "./GetInAppPurchasedAmountEditorCmp.vue?vue&type=style&index=0&id=b185105c&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__